import React from "react";
import { CREATORS, formatFollowers } from "@/lib/mockData";
import { Instagram, Youtube, Star } from "lucide-react";

const FeaturedCreators = () => {
  return (
    <section id="creators" className="relative border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
          <div className="max-w-xl">
            <p className="text-xs uppercase tracking-[0.2em] text-blue-400 mb-3">
              Featured roster
            </p>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter text-zinc-50"
              data-testid="creators-heading"
            >
              Hand-picked creators. Verified audiences. Real results.
            </h2>
          </div>
          <p className="text-sm text-zinc-500">Swipe →</p>
        </div>

        <div className="flex gap-5 overflow-x-auto scrollbar-hide -mx-6 px-6 pb-2">
          {CREATORS.slice(0, 8).map((c) => (
            <article
              key={c.id}
              className="group min-w-[280px] sm:min-w-[300px] rounded-2xl border border-white/8 bg-white/[0.02] p-5 transition-all duration-300 hover:border-blue-500/40 hover:shadow-[0_0_30px_rgba(37,99,235,0.18)] hover:-translate-y-1"
              data-testid={`featured-creator-${c.id}`}
            >
              <div className="flex items-center gap-3">
                <img
                  src={c.avatar}
                  alt={c.name}
                  className="h-12 w-12 rounded-full object-cover ring-2 ring-white/10"
                />
                <div>
                  <div className="text-sm font-semibold text-zinc-50">{c.name}</div>
                  <div className="text-xs text-zinc-500">{c.handle}</div>
                </div>
              </div>

              <div className="mt-5 flex items-center justify-between">
                <div className="flex items-center gap-2 text-xs text-zinc-300">
                  {c.primaryPlatform === "YouTube" ? (
                    <Youtube className="h-4 w-4 text-zinc-400" />
                  ) : (
                    <Instagram className="h-4 w-4 text-zinc-400" />
                  )}
                  <span className="font-medium">{formatFollowers(c.followers)}</span>
                </div>
                <span className="text-xs px-2 py-0.5 rounded-full bg-blue-500/10 border border-blue-500/30 text-blue-300">
                  {c.er}% ER
                </span>
              </div>

              <div className="mt-4 flex flex-wrap gap-1.5">
                {c.niches.map((n) => (
                  <span
                    key={n}
                    className="text-[11px] px-2 py-0.5 rounded-md bg-white/[0.04] border border-white/8 text-zinc-300"
                  >
                    {n}
                  </span>
                ))}
              </div>

              <div className="mt-5 pt-4 border-t border-white/5 flex items-center justify-between text-xs text-zinc-500">
                <span>{c.location}</span>
                <span className="flex items-center gap-1">
                  <Star className="h-3 w-3 fill-amber-400 text-amber-400" /> {c.rating}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedCreators;
